import {
  differenceInCalendarDays,
  format,
  isAfter,
  isBefore,
  isEqual,
  isValid,
  parseISO,
  parse
} from 'date-fns';
import { UTCDate } from '@date-fns/utc';
import { TZDate } from '@date-fns/tz';

export function formatDate(
  date: UTCDate | null | undefined,
  formatStr: string = 'MMM do yyyy'
): string {
  return !date ? '-' : format(new TZDate(date, 'UTC'), formatStr);
}

export function formatDateString(date: string | null | undefined): string {
  return date && (isValid(date) || isValid(parseISO(date))) ? formatDate(new UTCDate(date)) : '-';
}

/**
 * Parse an iso date i.e. 2022-02-25 and return a UTCDate ignoring local system timezones
 * @param dateStr
 */
export function parseDateString(dateStr: string): UTCDate {
  if (!isValidDate(dateStr)) throw new Error(`Invalid date (yyyy-MM-dd) : ${dateStr}`);
  return new UTCDate(dateStr);
}

export function isValidDate(dateString: string) {
  return isValid(parse(dateString, 'yyyy-MM-dd', new UTCDate()));
}

export function UTCYesterday(): UTCDate {
  const yesterday = new UTCDate();
  yesterday.setDate(yesterday.getDate() - 1);
  return yesterday;
}

export function isBeforeOrEqual(firstDate: UTCDate, secondDate: UTCDate): boolean {
  return (
    isValid(firstDate) &&
    (isValid(secondDate) ? isEqual(firstDate, secondDate) || isBefore(firstDate, secondDate) : true)
  );
}

export function isAfterOrEqual(newDate: UTCDate, secondDate: UTCDate): boolean {
  return (
    isValid(newDate) &&
    (isValid(secondDate) ? isEqual(newDate, secondDate) || isAfter(newDate, secondDate) : true)
  );
}

export function calcNumDays(startDate: string, endDate: string) {
  const start = new UTCDate(startDate);
  const end = new UTCDate(endDate);
  if (!isValid(start) || !isValid(end) || !isBeforeOrEqual(start, end)) {
    return '--';
  }
  return (differenceInCalendarDays(end, start) + 1).toLocaleString();
}

export function calcNumUTCDays(startDate: UTCDate, endDate: UTCDate) {
  if (!isBeforeOrEqual(startDate, endDate)) {
    return '--';
  }
  return (differenceInCalendarDays(endDate, startDate) + 1).toLocaleString();
}
